module.exports = __webpack_public_path__ + "static/media/steno-ss.8bfb7286.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/steno-ss.png
 ** module id = 236
 ** module chunks = 0
 **/